export default {
  title: 'Descuentos/Cargos globales antes de impuestos'
}
